/**
 * @file MemberDailySummary.jsx
 * @location src/components/mypage/MemberDailySummary.jsx
 * @role 팀원 업무탭 최상단 — 하루 첫 진입 1회 요약 배너(오늘 N건 · 예정 N건).
 *   닫으면 그날 다시 안 뜸(uiPrefs.memberSummarySeenDate). 측정 아님 — 행동 라우팅(razor ④ 가드).
 */
import { useApp } from '../../store/AppContext';
import { Icon } from '../ui/Icon';

/**
 * @param {object} props
 * @param {number} props.todayCount  오늘 처리할 업무 수(미완·비예정)
 * @param {number} props.futureCount 예정 업무 수(미래 지정일)
 * @param {string} props.today YYYY-MM-DD
 */
export function MemberDailySummary({ todayCount, futureCount, today }) {
  const { S, act } = useApp();
  if (S.uiPrefs?.memberSummarySeenDate === today) return null;

  const dismiss = () => act('SET_UI_PREF', { key: 'memberSummarySeenDate', value: today });

  return (
    <div className="member-summary">
      <span className="member-summary-icon"><Icon name="sun" size={16} /></span>
      <span className="member-summary-text">
        오늘 <b>{todayCount}</b>건{futureCount > 0 && <> · 예정 <b>{futureCount}</b>건</>}
      </span>
      <button type="button" className="member-summary-close" onClick={dismiss} aria-label="닫기">
        <Icon name="x" size={14} />
      </button>
    </div>
  );
}
